import React, { Component } from "react";
import { Header, Segment } from "semantic-ui-react";

class RenderedApp extends Component {
  constructor(props) {
    super(props);
    this.onEnter = this.onEnter.bind(this);
  }

  onEnter(e, obj) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  }

  processItem(application) {
    // switch (application.question.type) {
    //   case "text":
        return (
          <Segment padded>
            <Header textAlign="left">{application.question}</Header>
            {/* {isUrl(item) ? (
              <a
                onKeyDown={this.onEnter}
                target="_blank"
                href={item}
                style={{ textAlign: "left" }}
              >
                {item}
              </a>
            ) : ( */}
              <p style={{ textAlign: "left" }}>{application.response}</p>
            {/* )} */}
          </Segment>
        );
    //   case "multiple":
    //     return this.addMultiple(application.question, application.response);
    // }
  }

  addMultiple(label, item) {
    console.log("adding multiple", label);
    let bullets = JSON.parse(item).map((it) => <li>{it}</li>);
    return (
      <Segment padded>
        <Header textAlign="left">{label}</Header>
        <ul style={{ textAlign: "left" }}>{bullets}</ul>
      </Segment>
    );
  }

  render() {
    if (this.props.app === null) {
      return <Header> No Applications found! </Header>;
    }
    console.log(this.props.app);

    let essays = Object.keys(this.props.app.answers).map((qid) => {
      return this.processItem(this.props.app.answers[qid]);
    })

    return (
      <Segment.Group style={{ overflowY: "auto", margin: 0 }}>
        {essays}
      </Segment.Group>
    );
  }
}

export default RenderedApp;



// WEBPACK FOOTER //
// ./src/components/grader/RenderedApp.js